import React from "react";
import HeaderMain from "../Header/HeaderMain";
import CarouselMain from "../Carousel/CarouselMain";
import FooterMain from "../Footer/FooterMain";
import MainPartners from "../OurPartners/MainPartners";
import UseCaseSection from "./LandingPageUseCase/UseCaseSection";
import useCases from "./LandingPageUseCase/useCases";
import LandStaffing from "./StaffingLanding/LandStaffing";
import SuccessStories from "../SuccessStories/SuccessStory";
import ModelGrid from "../Model/ModelGrid";
import SmallSnackBar from "../SmallSnackBar/SmallSnackBar";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import WhatsAppButton from "../Whatsapp/WhatsappButton";

function LandingPage() {
  return (
    <>
      <SmallSnackBar />
      <HeaderMain />

      <main>
        {/* The page's single h1. It was previously missing entirely while each
            of the seven sections below declared its own, so the page had seven
            top-level headings and no statement of what it is. */}
        <h1 className="visually-hidden">
          Happy Technovation — CAD automation, AI/ML, computer vision, full
          stack development, PLM solutions and engineering staffing
        </h1>

        <CarouselMain />
        <ModelGrid />

        {useCases.map((useCase, index) => (
          <UseCaseSection key={useCase.id} useCase={useCase} index={index} />
        ))}

        <LandStaffing />
        <MainPartners />
        <SuccessStories />
      </main>

      <FooterMain />
      <ScrollToTop />
      <WhatsAppButton />
    </>
  );
}

export default LandingPage;
